import React from "react";
import get from "lodash/get";
import Helmet from "react-helmet";

import Gallery from "../components/Gallery";

import thumb01 from "../assets/images/thumbs/blumenstecker-pinguin.jpg";
import thumb02 from "../assets/images/thumbs/lampenschirm_1.jpg";
import thumb03 from "../assets/images/thumbs/duftstoevchen_1.jpg";
import thumb04 from "../assets/images/thumbs/glasschale-weiß_blau.jpg";
import thumb05 from "../assets/images/thumbs/windlicht-bunt.jpg";
import thumb06 from "../assets/images/thumbs/hohe-bonbon-dose_1.jpg";
import thumb07 from "../assets/images/thumbs/stielwindlicht-blau.jpg";
import thumb08 from "../assets/images/thumbs/glasengel_1.jpg";

import full01 from "../assets/images/fulls/blumenstecker-pinguin.jpg";
import full02 from "../assets/images/fulls/lampenschirm_1.jpg";
import full03 from "../assets/images/fulls/duftstoevchen_1.jpg";
import full04 from "../assets/images/fulls/glasschale-weiß_blau.jpg";
import full05 from "../assets/images/fulls/windlicht-bunt.jpg";
import full06 from "../assets/images/fulls/hohe-bonbon-dose_1.jpg";
import full07 from "../assets/images/fulls/stielwindlicht-blau.jpg";
import full08 from "../assets/images/fulls/glasengel_1.jpg";

const DEFAULT_IMAGES = [
  {
    id: "1",
    src: full01,
    thumbnail: thumb01,
    caption: "Blumenstecker",
    description: "Handbemalt – jedes Stück ein Unikat."
  },
  {
    id: "2",
    src: full02,
    thumbnail: thumb02,
    caption: "Lampenschirm",
    description: "Dekoratives Licht mit Glas-Charakter."
  },
  {
    id: "3",
    src: full03,
    thumbnail: thumb03,
    caption: "Duftstövchen",
    description: "Klein, fein – ideal als Geschenk."
  },
  {
    id: "4",
    src: full04,
    thumbnail: thumb04,
    caption: "Schale",
    description: "Farbe & Form – mundgeblasen."
  },
  {
    id: "5",
    src: full05,
    thumbnail: thumb05,
    caption: "Windlicht",
    description: "Leuchtet warm – drinnen wie draußen."
  },
  {
    id: "6",
    src: full06,
    thumbnail: thumb06,
    caption: "Bonbon-Dose",
    description: "Praktisch & dekorativ."
  },
  {
    id: "7",
    src: full07,
    thumbnail: thumb07,
    caption: "Stielwindlicht",
    description: "Elegante Silhouette, klare Farben."
  },
  {
    id: "8",
    src: full08,
    thumbnail: thumb08,
    caption: "Glasengel",
    description: "Ein Klassiker – mit Zertifikat."
  }
];

class HomeIndex extends React.Component {
  render() {
    const siteTitle = get(this, "props.data.site.siteMetadata.title");
    const siteDescription = get(this, "props.data.site.siteMetadata.description");

    return (
      <div>
        <Helmet>
          <title>{siteTitle}</title>
          <meta name="description" content={siteDescription} />
        </Helmet>

        <div id="main">
          <section id="one">
            <header className="major">
              <h2>Glaskunst aus Handarbeit</h2>
            </header>
            <p>
              Willkommen bei <strong>Glaskunst Seidelmann</strong>. Hier sehen Sie
              eine kleine Auswahl unserer kunstvoll hergestellten und bemalten
              Unikate (mit Zertifikat).
            </p>
            <p>
              Für Fragen erreichen Sie uns telefonisch unter
              <strong> 08208 / 959255</strong> oder per E‑Mail an
              <a href="mailto:info@glaskunst-seidelmann.de">
                {' '}info@glaskunst-seidelmann.de
              </a>.
            </p>

            <ul className="actions">
              <li>
                <a href="#arbeiten" className="button special">
                  Arbeiten ansehen
                </a>
              </li>
              <li>
                <a href="#kontakt" className="button">
                  Kontakt
                </a>
              </li>
            </ul>
          </section>

          <section id="arbeiten">
            <h2>Arbeiten</h2>
            <p>
              Tipp: Klicken Sie auf ein Bild, um es im Großformat zu sehen.
            </p>

            <Gallery
              images={DEFAULT_IMAGES.map(
                ({ src, thumbnail, caption, description }) => ({
                  src,
                  thumbnail,
                  caption,
                  description
                })
              )}
            />
          </section>

          <section id="kontakt">
            <h2>Kontakt</h2>
            <p>
              Schreiben Sie uns eine Nachricht – wir melden uns zeitnah zurück.
            </p>
            <div className="row">
              <div className="8u 12u$(small)">
                <form
                  name="contact"
                  method="post"
                  action="/danke"
                  data-netlify="true"
                  data-netlify-honeypot="bot-field"
                >
                  <input type="hidden" name="form-name" value="contact" />
                  <div className="row uniform 50%">
                    <div className="6u 12u$(xsmall)">
                      <input
                        type="text"
                        name="name"
                        id="name"
                        placeholder="Name"
                        required
                      />
                    </div>
                    <div className="6u 12u$(xsmall)">
                      <input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="E‑Mail"
                        required
                      />
                    </div>
                    <div className="12u">
                      <textarea
                        name="message"
                        id="message"
                        placeholder="Nachricht"
                        rows="4"
                        required
                      />
                    </div>
                  </div>
                  <ul className="actions">
                    <li>
                      <input type="submit" value="Senden" />
                    </li>
                  </ul>
                </form>
              </div>
              <div className="4u 12u$(small)">
                <ul className="labeled-icons">
                  <li>
                    <h3 className="icon fa-home">
                      <span className="label">Adresse</span>
                    </h3>
                    Aretinstraße 32
                    <br />
                    86316 Rinnenthal
                  </li>
                  <li>
                    <h3 className="icon fa-mobile">
                      <span className="label">Telefon</span>
                    </h3>
                    08208 / 959255
                  </li>
                  <li>
                    <h3 className="icon fa-envelope-o">
                      <span className="label">E‑Mail</span>
                    </h3>
                    <a href="mailto:info@glaskunst-seidelmann.de">
                      info@glaskunst-seidelmann.de
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export default HomeIndex;

export const pageQuery = graphql`
  query PageQuery {
    site {
      siteMetadata {
        title
        description
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js